module.exports = __webpack_public_path__ + "Flag-652.3f219ef95e18b7740c932dd91e84e945.svg";